import {createAsyncThunk} from '@reduxjs/toolkit';
import api from 'services/axios';

const handleProductsDetailsFilters = (filters) => {
  let url = ``;
  if (filters?.search) {
    url += `&search=${filters.search}`;
  }
  if (filters?.categories?.length) {
    filters.categories.map((item) => {
      url += `&categories[]=${item.id}`;
    });
  }
  if (filters?.sortType && filters?.sortBy) {
    url += `&sort_type=${filters.sortType}&sort_by=${filters.sortBy}`;
  }
  return url;
};

export const getCycle = createAsyncThunk<any, any>('getCycle', async (params, thunkApi) => {
  try {
    const response = await api.get(`/dasht/promotion/cycles/inprogress?vid=${params.vendorId}`, {
      goBaseUrl: true
    });
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getProductsTotalList = createAsyncThunk<any, any>(
  'getProductsTotalList',
  async (params, thunkApi) => {
    try {
      const response = await api.get(
        `/dasht/promotion/cycles/${params.cycle_id}/products/contributed?vid=${params.vendor_id}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getProductsDetailsList = createAsyncThunk<any, any>(
  'getProductsDetailsList',
  async (params, thunkApi) => {
    try {
      const url = handleProductsDetailsFilters(params.filters);
      const response = await api.get(
        `promotion-center/suggested-product/detail-list?vendor_id=${params.vendorId}&cycle_id=${params.cycleId}&page_size=${params.pageSize}&page=${params.page}${url}`,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue({data: response.data, searchPage: params.searchPage});
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const approveProductList = createAsyncThunk<any, any>(
  'approveProductList',
  async (data, thunkApi) => {
    try {
      const requestData = {
        ...data,
        products: data.products.map((product) => ({
          ...product,
          product_id: Number(product.product_id),
          vendor_discount: Number(product.vendor_discount)
        }))
      };
      const response = await api.put(
        `/dasht/promotion/cycles/${requestData.cycle_id}/products?vid=${requestData.vendor_id}`,
        requestData,
        {
          goBaseUrl: true
        }
      );
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getFilters = createAsyncThunk<any, any>('getFilters', async (params, thunkApi) => {
  try {
    const response = await api.get(
      `/dasht/promotion/cycles/${params.cycle_id}/products/filter?vid=${params.vendor_id}`,
      {
        goBaseUrl: true
      }
    );
    return thunkApi.fulfillWithValue(response.data);
  } catch (e: any) {
    return thunkApi.rejectWithValue(e);
  }
});

export const getDiscountList = createAsyncThunk<any, any>(
  'getDiscountList',
  async (data, thunkApi) => {
    try {
      const response = await api.get(`/dasht/promotion/cycles/${data.cycle_id}`, {
        params: data,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getDiscountFilters = createAsyncThunk<any, any>(
  'getDiscountFilters',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`/dasht/promotion/cycles`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getCycleDetails = createAsyncThunk<any, any>(
  'getCycleDetails',
  async (params, thunkApi) => {
    try {
      const response = await api.get(`dasht/promotion/cycles/${params.cycle_id}/products`, {
        params,
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);

export const getVendorsPromotions = createAsyncThunk<any, any>(
  'promotionCenter/getVendorsPromotions',
  async (params, thunkApi) => {
    try {
      const response = await api.get('/dasht/vendors/promotions', {
        params: {vendor_id: params.vendor_id},
        goBaseUrl: true
      });
      return thunkApi.fulfillWithValue(response.data?.data);
    } catch (e: any) {
      return thunkApi.rejectWithValue(e);
    }
  }
);
